import "./footer.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import InfoIcon from "@mui/icons-material/Info";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

function Footer() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const navigate = useNavigate();
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [popup, setPopup] = useState(false);
    const [showAppNotice, setShowAppNotice] = useState(false); // State cho thông báo App
    const [isPlaying, setIsPlaying] = useState(false);
    const [audio, setAudio] = useState(null);

    const MP3_URL = "https://wmmy.hip288.net/sounds/bgm/ui6_8/Music_11.mp3";

    useEffect(() => {
        if (localStorage.getItem("setting") !== null && localStorage.getItem("setting") !== "undefined") {
            setSetting(JSON.parse(localStorage.getItem("setting")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
            });
        }
    }, []);

    useEffect(() => {
        const newAudio = new Audio(MP3_URL);
        setAudio(newAudio);
        return () => {
            newAudio.pause();
        };
    }, []);

    const toggleAudio = () => {
        if (audio) {
            if (audio.paused) {
                audio.play().catch(error => console.log("Lỗi phát nhạc:", error));
            } else {
                audio.muted = !audio.muted;
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <>
            <footer>
                <div className="footer_top">
                    <ul className="container">
                        <li>
                            <a href="#" data-type="phone">
                                <img src={require("../../image/common/icon-phone.png")} alt="" />
                                <p>Hotline</p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={require("../../image/common/icon-email.png")} alt="" />
                                <p>
                                    <span className="cfgMainEmail">BIA66@gmail.com</span>
                                </p>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src={require("../../image/common/icon-footerWork.png")} alt="" />
                                <p>ĐẠI LÝ</p>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => window.open(`${setting?.cskh}`, "_blank")}>
                                <img src={require("../../image/common/icon-service.png")} alt="" />
                                <p>Chăm Sóc Khách Hàng</p>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="footer">
                    <div className="container">
                        <div className="marquee game-logo">
                            <div className="marquee-content">
                                {[...Array(12)].map((_, i) => (
                                    <div key={i} className={`logo-game logo-game-${i + 1}`} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">COPYRIGHT © BIA66 ALL RIGHTS RESERVED</div>
            </footer>

            <div className="br_right_bar">
                <div className="br_bar_mnav active">
                    {/* Nút Âm thanh */}
                    <div className="br_sbgimg noticeBoard" onClick={toggleAudio}>
                        <span className="br_rightbar_icon">
                            {isPlaying ? (
                                <VolumeUpIcon style={{ width: "28px", height: "28px", marginTop: "10px" }} />
                            ) : (
                                <VolumeOffIcon style={{ width: "28px", height: "28px", marginTop: "10px" }} />
                            )}
                        </span>
                        <p>{!isPlaying ? "Bật nhạc" : "Tắt nhạc"}</p>
                    </div>

                    {/* Nút Hỗ trợ */}
                    <div className="br_sbgimg liveChat" onClick={() => window.open(`${setting?.cskh}`, "_blank")}>
                        <span className="br_rightbar_icon">
                            <SupportAgentIcon style={{ width: "28px", height: "28px", marginTop: "10px" }} />
                        </span>
                        <p>Hỗ trợ trực tuyến</p>
                    </div>

                 

                    {/* Nút Khuyến mãi */}
                    <div className="br_sbgimg promotion" onClick={() => navigate("/promotion")}>
                        <span className="br_rightbar_icon">
                            <svg aria-hidden="true" className="svg-icon">
                                <use xlinkHref="#icon-promotion"></use>
                            </svg>
                        </span>
                        <p>Khuyến mãi</p>
                    </div>
                </div>
            </div>

            {/* Modal thông báo sắp ra mắt */}
            {showAppNotice && (
                <div className="custom-modal-overlay" onClick={() => setShowAppNotice(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-icon">🚀</div>
                        <h3>Thông báo</h3>
                        <p>Chức năng tải ứng dụng đang được bảo trì và sẽ sớm ra mắt quý khách!</p>
                        <button className="modal-btn" onClick={() => setShowAppNotice(false)}>Đóng</button>
                    </div>
                </div>
            )}
        </>
    );
}
export default Footer;